<div class="mini-card-container">
    <div class="mini-card-title">{{cardItem.name}}</div>

    <div *ngIf="cardItem.type === 'label'" class="mini-card-value">{{cardItem.value}}</div>
    <div *ngIf="cardItem.type === 'date'" class="mini-card-value">{{cardItem.value | date:'fullDate' || cardItem.value}}
    </div>
    <div *ngIf="cardItem.type === 'image'">
        <img *ngIf="cardItem.value.length > 0" class="mini-card-image" [src]="'data:image/jpg;base64,'+cardItem.value"
            height="80px" />
        <div *ngIf="cardItem.value.length === 0" class="mini-card-value">Not Available </div>
    </div>

</div>